import React, { useState , useEffect} from "react";
import axios from "axios";
import "../css/kycformnew.css";
import { useDispatch, useSelector } from "react-redux";

import { fetchEmployeeReport } from "../redux/slices/employeeReportSlice";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheck, faTimes, faTrash } from "@fortawesome/free-solid-svg-icons";

import { faDownload } from "@fortawesome/free-solid-svg-icons";



export default function CustomerKyc() {
    const dispatch = useDispatch();
  const [filterType, setFilterType] = useState("customer id");
  const [filterValue, setFilterValue] = useState("");
  const [selectedEmployee, setSelectedEmployee] = useState("");
  const [userDetails, setUserDetails] = useState(null);
  const [uploadedKyc, setUploadedKyc] = useState([]);
  const [previewImage, setPreviewImage] = useState(null);


  const { list: data, loading, error, currentPage, totalPages } = useSelector(
      (state) => state.employeeReport
    );

  // ------------------ Employee Dropdown (Static) ------------------
  const employees = [
    { id: "101", name: "Rahul Sharma" },
    { id: "102", name: "Priya Verma" },
    { id: "103", name: "Amit Singh" },
    { id: "104", name: "Sneha Patel" },
  ];


  const pageSize = 250;
  
    const fetchData = (page = 1) => {
      dispatch(fetchEmployeeReport({ page, pageSize }));
    };
  
    useEffect(() => {
      fetchData(1);
    }, []);
  

    const handlePreviewClick = (docImage) => {
      if (!docImage) return;

      const imageUrl = `https://narrowitsolution.in/uploads/${docImage}`;
      setPreviewImage(imageUrl);
    };






  // ------------------ Search User ------------------
const handleSearch = async () => {
  if (!filterValue) {
    alert("Please enter a value to search.");
    return;
  }
  if (!selectedEmployee) {
    alert("Please select an employee first.");
    return;
  }

  const superAdminId = localStorage.getItem("adminuserId") || "14";
  let query = { superAdminId, branchId: selectedEmployee };

  if (filterType === "customer id") query.userId = filterValue.trim();
  else if (filterType === "pan") query.panNumber = filterValue.trim();
  else if (filterType === "aadhaar") query.aadhaarNumber = filterValue.trim();
  else if (filterType === "mobile") query.mobileNumber = filterValue.trim();
  else {
    alert("This filter type is not supported for API search.");
    return;
  }

  try {
    const response = await axios.get(
      "https://narrowitsolution.in/api/customers-get-userId",
      { params: query }
    );

    const user = response.data.data;
    if (user && user.userId) {
      const details = {
        userId: user.userId,
        Id: user.id,
        name: user.fullName,
        pan: user.panNumber,
        aadhaar: user.aadhaarNumber,
        mobile: user.mobileNumber,
        dob: user.dateOfBirth?.slice(0, 10),
        superAdminId: user.superAdminId,
        createdId: user.branchId, // ✅ save createdId for KYC filter
      };
      setUserDetails(details);

      // ✅ Add createdId & superAdminId to KYC fetch
      const kycResponse = await axios.get(`https://narrowitsolution.in/api/list-kyc`, {
        params: {
          userId: user.userId,
          superAdminId: user.superAdminId,
          createdId: user.branchId,
        },
      });

      setUploadedKyc(kycResponse.data.documents || []);
    } else {
      setUserDetails(null);
      setUploadedKyc([]);
      alert("No user found.");
    }
  } catch (error) {
    console.error("Error fetching user or KYC:", error);
    alert("Failed to fetch user or KYC. Please try again.");
  }
};

  // ------------------ Approve / Reject KYC ------------------
  const handleAction = async (docId, action) => {
    try {
      const url =
        action === "approved"
          ? `https://narrowitsolution.in/api/approve-customer-kyc/${docId}`
          : `https://narrowitsolution.in/api/reject-customer-kyc/${docId}`;

      await axios.post(url);

      alert(
        action === "approved"
          ? "✅ KYC Document Approved!"
          : "❌ KYC Document Rejected!"
      );

      // Refresh documents
      if (userDetails) {

        console.log("userDetails");
        console.log(userDetails);
        console.log("userDetails");
        const kycResponse = await axios.get(`https://narrowitsolution.in/api/list-kyc`, {
           params: {
          userId: userDetails.userId,
          superAdminId: userDetails.superAdminId,
          createdId: userDetails.createdId,
        },
        });
        setUploadedKyc(kycResponse.data.documents || []);
      }
    } catch (error) {
      console.error("Error updating KYC:", error);
      alert("Failed to update KYC status. Please try again.");
    }
  };

const handleDelete = async (docId) => {
  if (!window.confirm("Are you sure you want to delete this document?")) return;

  try {
    const res = await fetch(`https://narrowitsolution.in/api/delete-customer-kyc/${docId}`, {
      method: "DELETE",
      headers: {
        "Content-Type": "application/json",
        // Add auth token if required
        // Authorization: `Bearer ${token}`,
      },
    });

    if (!res.ok) throw new Error("Failed to delete document");

    // Remove deleted document from local state
    setUploadedKyc(uploadedKyc.filter((doc) => doc.id !== docId));

    alert("Document deleted successfully");
  } catch (error) {
    console.error(error);
    alert("Error deleting document");
  }
};

const handleDownload = async (docImage) => {
  try {
    const fileUrl = `https://narrowitsolution.in/uploads/${docImage}`;

    const response = await fetch(fileUrl);
    const blob = await response.blob();

    const blobUrl = window.URL.createObjectURL(blob);

    const a = document.createElement("a");
    a.href = blobUrl;
    a.download = docImage;
    document.body.appendChild(a);
    a.click();

    window.URL.revokeObjectURL(blobUrl);
    document.body.removeChild(a);
  } catch (error) {
    console.error("Download failed", error);
    alert("Download failed");
  }
};




  // ------------------ JSX ------------------
  return (
    <div className="BranchLoanKycUpload-container">
      <h1>Customer KYC Management</h1>

      {/* Step 1 - Filter Section */}
      <section className="BranchLoanKycUpload-section-filter">
        <h2>1. Filter User</h2>
        <div className="BranchLoanKycUpload-filter-row-wrapper">
          <div className="BranchLoanKycUpload-filter-row">
            {/* Employee Dropdown */}
            <select
              value={selectedEmployee}
              onChange={(e) => setSelectedEmployee(e.target.value)}
            >
              <option value="">Select Employee</option>
              {data.map((emp) => (
                <option key={emp.id} value={emp.id}>
                  {emp.fullName}- {emp.id}
                </option>
              ))}
            </select>

            {/* Filter Type Dropdown */}
            {/* <select
              value={filterType}
              onChange={(e) => {
                setFilterType(e.target.value);
                setFilterValue("");
              }}
            >
              <option value="">Select Filter Type</option>
              <option value="customer id">Customer ID</option>
              <option value="pan">PAN</option>
              <option value="aadhaar">Aadhaar</option>
              <option value="mobile">Mobile</option>
            </select> */}

            {/* Input Field */}
            {/* {filterType && ( */}
              <input
                type="text"
                placeholder={`Enter ${filterType}`}
                value={filterValue}
                onChange={(e) => setFilterValue(e.target.value)}
              />
            {/* )} */}
          </div>
        </div>
        <button className="c-kyc-btn-search" onClick={handleSearch}>
              🔍 Search
         </button>
      </section>

      {/* Step 2 - User Details */}
      {/* {userDetails && (
        <section className="BranchLoanKycUpload-section">
          <h2>2. User Details</h2>
          <div className="table-wrapper">
            <table className="BranchLoanKycUpload-user-details-table">
              <tbody>
                <tr>
                  <th>User ID</th>
                  <td>{userDetails.userId}</td>
                </tr>
                <tr>
                  <th>Name</th>
                  <td>{userDetails.name}</td>
                </tr>
                <tr>
                  <th>PAN</th>
                  <td>{userDetails.pan}</td>
                </tr>
                <tr>
                  <th>Customer ID</th>
                  <td>{userDetails.Id}</td>
                </tr>
                <tr>
                  <th>Aadhaar</th>
                  <td>{userDetails.aadhaar}</td>
                </tr>
                <tr>
                  <th>Mobile</th>
                  <td>{userDetails.mobile}</td>
                </tr>
                <tr>
                  <th>Date of Birth</th>
                  <td>{userDetails.dob}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </section>
      )} */}

      <section className="BranchLoanKycUpload-section">
          <h2>2. User Details</h2>
          <div className="table-wrapper">
            {/* <table className="BranchLoanKycUpload-user-details-table">
              <tbody>
                <tr>
                  <th>User ID</th>
                  <td>{userDetails?.userId}</td>
                </tr>
                <tr>
                  <th>Name</th>
                  <td>{userDetails?.name}</td>
                </tr>
                <tr>
                  <th>PAN</th>
                  <td>{userDetails?.pan}</td>
                </tr>
                <tr>
                  <th>Customer ID</th>
                  <td>{userDetails?.Id}</td>
                </tr>
                <tr>
                  <th>Aadhaar</th>
                  <td>{userDetails?.aadhaar}</td>
                </tr>
                <tr>
                  <th>Mobile</th>
                  <td>{userDetails?.mobile}</td>
                </tr>
                <tr>
                  <th>Date of Birth</th>
                  <td>{userDetails?.dob}</td>
                </tr>
              </tbody>
            </table> */}  
          </div>
          <div className="customer-details-wrapper">
             <div className="customerkyc-input-groups">
                    <label>User Id</label>
                    <input type="text" value={userDetails?.userId|| ""} readOnly />
            </div> 
             <div className="customerkyc-input-groups">
                    <label>Name</label>
                    <input type="text" value={userDetails?.name|| ""} readOnly />
            </div> 
             <div className="customerkyc-input-groups">
                    <label>Pan Number</label>
                    <input type="text" value={userDetails?.pan|| ""} readOnly />
            </div> 
             <div className="customerkyc-input-groups">
                    <label>Customer Id</label>
                    <input type="text" value={userDetails?.Id|| ""} readOnly />
            </div> 
             <div className="customerkyc-input-groups">
                    <label>Aadhar Number</label>
                    <input type="text" value={userDetails?.aadhaar|| ""} readOnly />
            </div> 
             <div className="customerkyc-input-groups">
                    <label>Mobile Number</label>
                    <input type="text" value={userDetails?.mobile|| ""} readOnly />
            </div> 
             <div className="customerkyc-input-groups">
                    <label>Date of Birth</label>
                    <input type="text" value={userDetails?.dob|| ""} readOnly />
            </div>
          </div>
      </section>


      <section className="BranchLoanKycUpload-section">
        <h2>3. Customer KYC Document Details</h2>
        <div className="table-wrapper">
          <table className="BranchLoanKycUpload-table">
            <thead>
              <tr>
                <th>S.No</th>
                <th>Document Name</th>
                <th>Status</th>
                <th>Preview</th>
                <th>Action</th>
                <th>Download</th>

                <th>Delete</th>
              </tr>
            </thead>
            <tbody>
              {uploadedKyc.length > 0 ? (
                uploadedKyc.map((doc, idx) => (
                  <tr key={doc.id}>
                    <td>{idx + 1}</td>
                    <td>{doc.docName}</td>
                    <td>
                      <span
                        className={`status-badge ${
                          doc.status === "approved"
                            ? "approved"
                            : doc.status === "rejected"
                            ? "rejected"
                            : "pending"
                        }`}
                      >
                        {doc.status || "Pending"}
                      </span>
                    </td>
                    <td>
                      {doc.docImage ? (
                        <button
                          className="preview-link"
                          onClick={() => handlePreviewClick(doc.docImage)}
                          type="button"
                        >
                          Preview
                        </button>
                      ) : (
                        "N/A"
                      )}
                    </td>

                    <td>
                     <button
                        className="ckyc-btn-accept"
                        onClick={() => handleAction(doc.id, "approved")}
                        type="button"
                        aria-label="Accept"
                        title="Accept"
                      >
                        <FontAwesomeIcon icon={faCheck} />
                      </button>

                      <button
                        className="ckyc-btn-reject"
                        onClick={() => handleAction(doc.id, "rejected")}
                        type="button"
                        aria-label="Reject"
                        title="Reject"
                      >
                        <FontAwesomeIcon icon={faTimes} />
                      </button> 
                    </td>

                    <td>
  {doc.docImage ? (
    <button
      className="ckyc-btn-download"
      title="Download"
      onClick={() => handleDownload(doc.docImage)}
      type="button"
    >
      <FontAwesomeIcon icon={faDownload} />
    </button>
  ) : (
    "N/A"
  )}
</td>




                      <td><button
                        className="ckyc-btn-delete"
                        title="Delete"
                        onClick={() => handleDelete(doc.id)}
                      >
                        <FontAwesomeIcon icon={faTrash} /> 
                      </button>
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="5" style={{ textAlign: "center" }}>
                    {userDetails
                      ? "No documents found"
                      : "Please search a user to view documents"}
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </section>
      
       {/* 🔹 Preview Modal */}
            {previewImage && (
              <div className="modal-overlay" onClick={() => setPreviewImage(null)}>
                <div className="modal-content" onClick={(e) => e.stopPropagation()}>
                  <img src={previewImage} alt="KYC Preview" className="modal-image" />
                  <button
                    className="modal-close"
                    onClick={() => setPreviewImage(null)}
                  >
                    X
                  </button>
                </div>
              </div>
            )}
    </div>
  );
}

